import { useState } from "react";
import { IonCol, IonGrid, IonRow, IonText } from "@ionic/react";
import { ExportRequests } from "components/Molecules";
import { Alert } from "swing-components";
import { generateSwingSupportURL } from "swing-utils";

import { COMBINED_RESTRICTIONS, translate, useShouldRestrictAdmin } from "~utils";

import { RequestType } from "./RequestIndex";

export function RequestsHeader(props: { requestType: RequestType }) {
  const [exportSuccessful, setExportSuccessful] = useState<boolean | undefined>(undefined);
  const hideCSVExportRequest = useShouldRestrictAdmin([COMBINED_RESTRICTIONS.VIEW_SUB_PAY]);

  return (
    <>
      <IonGrid class="mw-800">
        {/* TODO remove flex style when shared Button component is used */}
        <IonRow className="items-center flex">
          <IonCol>
            <h1>
              {props.requestType === "active-requests"
                ? translate("ROUTE_TABLE_ACTIVE_REQUESTS")
                : translate("ROUTE_TABLE_PAST_REQUESTS")}
            </h1>
          </IonCol>
          {/* Remove style when shared Button component is used */}
          <IonCol css={{ display: "contents" }}>
            {!hideCSVExportRequest && (
              <ExportRequests
                requestType={props.requestType}
                onSuccess={() => setExportSuccessful(true)}
                onFailure={() => setExportSuccessful(false)}
              />
            )}
          </IonCol>
        </IonRow>
        <IonRow>
          {exportSuccessful === false && (
            <div className="pt-8 pb-4 w-full">
              <Alert
                showIcon
                color="danger"
                title={translate("EXPORT_REQUEST_ERROR_LABEL")}
                onDismiss={() => {
                  setExportSuccessful(undefined);
                }}
              >
                <span>
                  {translate("LABEL_CONTACT_SUPPORT_1")}{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={generateSwingSupportURL("/hc/en-us/requests/new")}
                  >
                    {translate("LABEL_CONTACT_SUPPORT")}
                  </a>{" "}
                  {translate("LABEL_CONTACT_SUPPORT_2")}
                </span>
              </Alert>
            </div>
          )}
          {exportSuccessful === true && (
            <div className="pt-8 w-full pb-4">
              <Alert
                showIcon
                color="success"
                title={translate("EXPORT_REQUEST_SUCCESS_LABEL")}
                onDismiss={() => {
                  setExportSuccessful(undefined);
                }}
              >
                <IonText className="text-base">{translate("EXPORT_REQUEST_SUCCESS_MSG")}</IonText>
              </Alert>
            </div>
          )}
        </IonRow>
      </IonGrid>
    </>
  );
}
